import React, { useEffect, useState } from "react";
import {
  Dialog,
  Button,
  Input,
  Radio,
  Message,
  DatePicker,
  Form,
} from "element-react";
import { FaPlus, FaMinus, FaUserPlus } from "react-icons/fa";
import TableView from "components/tableView";
import {
  AssignArticleForEditor,
  userWithAssignedInfo,
} from "store/actions/articles";
import { useDispatch } from "react-redux";
import RoleEnum from "constants/roleEnum";
import { dateFormat } from "helpers/dateHelper";

const AssignUser = (assignProps) => {
  const [isVisible, setVisible] = useState(false);
  const onAssingClick = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <Button size="mini" onClick={() => onAssingClick()}>
        <FaUserPlus />
        Assign
      </Button>
      {isVisible && (
        <Dialog
          closeOnClickModal={false}
          title="Assign Editor"
          visible={isVisible}
          onCancel={handleCancel}
          style={{ width: "800px" }}
        >
          <Dialog.Body>
            <div>
              <Editors {...assignProps} onSave={handleCancel} />
            </div>
          </Dialog.Body>
        </Dialog>
      )}
    </>
  );
};

const Editors = (props) => {
  const { row, dispatch, articlesRef, onSave } = props;
  const [loading, setLoading] = useState(false);
  const [editorName, setEditorName] = useState("");
  const [state, setState] = useState({
    remarks: "",
    reviewDueDate: null,
  });
  const [selectedIndex, setSelectedIndex] = useState(-1);

  useEffect(() => {
    fetchData("", state);
  }, []);
  const [tableData, setTableData] = useState([]);

  const fetchData = async (fullname, preState) => {
    var res: any = await dispatch(
      userWithAssignedInfo({
        articleId: row.Id,
        fullname: fullname,
        role: RoleEnum.Editor,
      })
    );
    const { Users } = res;
    var index = Users?.findIndex((x) => x.IsAssigned);
    setSelectedIndex(index);
    setTableData(Users);
    setState({
      ...preState,
      remarks: res.Remarks,
      reviewDueDate: res.ReviewDueDate,
    });
  };

  const onChangeSearch = async (name, val) => {
    setEditorName(val);

    // Reset selection
    setSelectedIndex(-1);

    // Debounce the API call to avoid excessive requests
    const timer = setTimeout(async () => {
      try {
        await fetchData(val, state);
      } catch (error) {}
    }, 800); // 300ms debounce delay

    // Cleanup function to cancel pending request if new one comes
    return () => clearTimeout(timer);
  };

  const onChangeDate = (name, date) => {
    setState({ ...state, [name]: dateFormat(date) });
  };

  const columns = [
    {
      label: "Editor",
      prop: "FullName",
      render: (row, column, index) => (
        <div onClick={() => setSelectedIndex(index)}>{row.FullName}</div>
      ),
    },
    {
      label: "Done",
      prop: "Done",
      width: 120,
      render: (row, column, index) => (
        <div onClick={() => setSelectedIndex(index)}>{row.Done}</div>
      ),
    },
    {
      label: "Active",
      prop: "Active",
      width: 120,
      render: (row, column, index) => (
        <div onClick={() => setSelectedIndex(index)}>{row.Active}</div>
      ),
    },
    {
      label: "",
      prop: "",
      width: 60,
      render: (row, column, index) => {
        return (
          <div onClick={() => setSelectedIndex(index)}>
            <Radio value="" checked={selectedIndex === index} />
          </div>
        );
      },
    },
  ];

  const onSaveClicked = async () => {
    if (selectedIndex === -1) {
      Message({
        message: "At least one editor is required.",
        type: "warning",
      });
      return;
    }
    var remarks = state.remarks;
    var reviewDueDate = state.reviewDueDate;
    var assignTo = tableData[selectedIndex].Id;
    const articleId = props && props.row.Id;
    const assignedAs = RoleEnum.Editor;
    setLoading(true);
    const res = await dispatch(
      AssignArticleForEditor({
        articleId,
        assignTo,
        assignedAs,
        remarks,
        reviewDueDate,
      })
    );
    setLoading(false);
    onSave();
    articlesRef && articlesRef.current.loadData();
  };
  return (
    <div>
      <Form className="demo-form-stacked" labelPosition="top" labelWidth="100">
        <Form.Item label="Reviewer">
          <div className="margin-bottom-10">
            <Input
              value={editorName}
              placeholder="Search Editor"
              onChange={(val: any) => onChangeSearch("editorName", val)}
            ></Input>
          </div>
        </Form.Item>
        <div className="margin-bottom-10">
          <Form.Item label="">
            <TableView showNoData={false} columns={columns} data={tableData} />
          </Form.Item>
        </div>
        <div className="margin-bottom-10">
          <Form.Item label="Review Due Date">
            <DatePicker
              value={state?.reviewDueDate && new Date(state.reviewDueDate)}
              placeholder="Review Due Date"
              onChange={(date) => onChangeDate("reviewDueDate", date)}
            />
          </Form.Item>
        </div>
        <div className="margin-bottom-10">
          <Form.Item label="Remarks">
            <Input
              type="textarea"
              value={state.remarks}
              onChange={(val: any) => setState({ ...state, remarks: val })}
            ></Input>
          </Form.Item>
        </div>
        <div className="flex-end">
          <Button type="primary" onClick={onSaveClicked} loading={loading}>
            Save
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default AssignUser;
